import { createFileRoute } from '@tanstack/react-router';

import { AllVersionsPage } from '@/features/versions/pages';

export const Route = createFileRoute('/_authenticated/_withWorkspace/versions/')({
  component: AllVersionsPage,
});
